import { MASONRY, RegionSelectionHome } from '@highmark-web/highmark-common';
import { RecentClaimsCardList } from '@leagueplatform/claims';
import {
  ActivityStackWidgetV2,
  HealthJourneyHome,
  HEALTH_JOURNEY_NAMESPACE,
  HEALTH_JOURNEY_NODE_TYPES,
} from '@leagueplatform/health-journey';
import { driver, wsDriver } from '@leagueplatform/masonry';

export const initAppMasonryRegistry = () => {
  driver.nodeRendererRegistry.registerRenderer(
    MASONRY.CUSTOM_WIDGET_TYPE_CLAIMS,
    MASONRY.MODULE_KEY_CLAIMS,
    RecentClaimsCardList,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY.CUSTOM_WIDGET_TYPE_HEALTH_JOURNEY,
    MASONRY.MODULE_KEY_HEALTH_JOURNEY,
    HealthJourneyHome,
  );

  wsDriver.nodeRendererRegistry.overrideRenderer(
    HEALTH_JOURNEY_NODE_TYPES.ACTIVITIES_WIDGET,
    HEALTH_JOURNEY_NAMESPACE,
    ActivityStackWidgetV2,
  );

  wsDriver.nodeRendererRegistry.registerRenderer(
    MASONRY.CUSTOM_WIDGET_REGION_BANNER,
    MASONRY.MODULE_KEY_CUSTOM_WIDGETS,
    RegionSelectionHome,
  );
};
